export class NewsModel {
  Id: any;
  Title: any;
  Content: any;
  CreatedAt: any;
  Category: any;
  Media:any;
  Media_type:string;
  IsToday: boolean = false;

  public mapToModel(data): NewsModel {
    const newsModel = new NewsModel();
    newsModel.Id = data.id;
    newsModel.Title = data.title;
    newsModel.Content = data.content;
    newsModel.CreatedAt = data.createdAt;
    newsModel.Media = data.media;
    newsModel.Category = data.category ? data.category : false;

    return newsModel;
  }
}
